import {
  REDUCER_NAMES_HISTORY_NO_MOVEMENTS,
} from '../../../constants'


import {
  createAllShipmentsHistorySelectorsHof,
} from './shipmentsHistoryHigherOrderFunctions'

export const {
  getProp,
  getPropOfAll,
  getEntireSlice,
  getAreAnyItemsInACertainStatus,
} = createAllShipmentsHistorySelectorsHof(REDUCER_NAMES_HISTORY_NO_MOVEMENTS)
